import React from 'react';
import QuestionAnswer from '../questionAndAnswer/QuestionAnswer';
import { useSelector } from 'react-redux';
import lang from '../../lang/lang.json';
import './mostaskedquestions.scss';
import CustomAnswer from '../questionAndAnswer/CustomAnswer';

const MostAskedQuestions = () => {
  const { language } = useSelector((state) => state.language);

  return (
    <div className="container">
      <div className="most-asked-question-container">
        <div className="most-asked-queston-div header-title">
          {lang.QUESTION_ASKED_TITLE[language]}
        </div>
        <div className="most-asked-queston-div">
          <QuestionAnswer
            id="one"
            name="nameOne"
            label={lang.QUESTION_ASKED_QUE_1[language]}
            text={lang.QUESTION_ASKED_ANS_1[language]}
          />
          <QuestionAnswer
            id="three"
            name="nameThree"
            label={lang.QUESTION_ASKED_QUE_3[language]}
            text={lang.QUESTION_ASKED_ANS_3[language]}
          />
          <QuestionAnswer
            id="four"
            name="nameFour"
            label={lang.QUESTION_ASKED_QUE_4[language]}
            text={lang.QUESTION_ASKED_ANS_4[language]}
          />
          {/* <QuestionAnswer
            id="five"
            name="nameFive"
            label={lang.QUESTION_ASKED_QUE_5[language]}
            text={lang.QUESTION_ASKED_ANS_5[language]}
          /> */}

          <CustomAnswer
            id="Seven"
            name="nameSeven"
            label={lang.QUESTION_ASKED_QUE_7[language]}
            text={lang.QUESTION_ASKED_ANS_7[language]}
            li1={lang.QUESTION_ASKED_ANS_7_1[language]}
            li2={lang.QUESTION_ASKED_ANS_7_2[language]}
            li3={lang.QUESTION_ASKED_ANS_7_3[language]}
            li4={lang.QUESTION_ASKED_ANS_7_4[language]}
            li5={lang.QUESTION_ASKED_ANS_7_5[language]}
          />
          <QuestionAnswer
            id="five"
            line="bottom"
            name="nameFive"
            label={lang.QUESTION_ASKED_QUE_5[language]}
            text={lang.QUESTION_ASKED_ANS_5[language]}
          />

          {/* <CustomAnswer
            id="six"
            name="nameSix"
            line="bottom"
            label={lang.QUESTION_ASKED_QUE_6[language]}
            text="Дархост қабул намешавад, агар:"
            li1="— муҳлати насия як моҳ бошад;"
            li2="— ҳозир муҳлати имтиёзнок дошта бошед;"
            li3="— дар бонки мо насия ё маблағгузории мошинро дер баргардондаед;"
            li4="— то маҳкамкунии насия ё маблағгузорӣ як моҳ монда бошад;"
            li5="— ҳуҷҷатҳои тасдиқкунандаи муфлис шуданро пешниҳод накардаед."
          /> */}
        </div>
      </div>
    </div>
  );
};

export default MostAskedQuestions;
